import noop from 'lodash/noop';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import {
	createStore,
	createHook,
	type Action,
	type BoundActions,
	type HookFunction,
} from '@atlassian/react-sweet-state';
import type { ViewModeOptions } from '@jira/issue__issue-view-model/src/ViewModeOptions.types.tsx';

type State = {
	isModalOpen: boolean;
	onClose: () => void;
	issueKey: string;
	packageName: string;
	analyticsSource: string;
	issueCreateSessionId?: string;
	viewModeOptions?: ViewModeOptions;
};

type OpenModalProps = Flow.Diff<
	State,
	{
		isModalOpen: boolean;
	}
>;

const initialState: State = {
	isModalOpen: false,
	onClose: noop,
	issueKey: '',
	packageName: '',
	analyticsSource: '',
	issueCreateSessionId: undefined,
	viewModeOptions: undefined,
};

const actions = {
	openIssueViewModal:
		(nextState: OpenModalProps): Action<State> =>
		({ setState }) => {
			setState({
				...initialState,
				...nextState,
				isModalOpen: true,
			});
		},
	closeIssueViewModal:
		(): Action<State> =>
		({ setState }) => {
			setState({
				...initialState,
				isModalOpen: false,
			});
		},
	setIssueCreateSessionId:
		(issueCreateSessionId: string): Action<State> =>
		({ setState }) => {
			setState({ issueCreateSessionId });
		},
} as const;

type Actions = typeof actions;

const store = createStore<State, Actions>({
	name: 'issue-view.controllers.open-issue-view-modal',
	initialState,
	actions,
});

export const useTriggerIssueViewModal: HookFunction<
	State,
	BoundActions<
		State,
		{
			readonly openIssueViewModal: (nextState: OpenModalProps) => Action<State>;
			readonly closeIssueViewModal: () => Action<State>;
			readonly setIssueCreateSessionId: (issueCreateSessionId: string) => Action<State>;
		}
	>,
	void
> = createHook(store);
